import React, { useState } from 'react'
import { Button, TextField, Link, Typography } from '@material-ui/core';
import { emailValidator, errorCodeTranslator, passwordValidator } from '../../api/utils/validator';
import { useHistory } from 'react-router';
import HelpSnackbar from '../utils/HelpSnackbar';
import { useCommProvider } from "../../api/CommProvider";
import { FcGoogle } from "react-icons/fc";
import { useTranslation } from "react-i18next";

export function Login() {
    const { t } = useTranslation("global")

    const history = useHistory();
    /* Firebase */
    const [email, setEmail] = useState({ value: "", error: "" });
    const [password, setPassword] = useState({ value: "", error: "" });
    const [errorText, setErrorText] = useState("");
    const { comm_login, comm_login_google_provider, comm_resetPassword, comm_guestLogin } = useCommProvider();
    /* Snackbar */
    const [snack, setSnack] = useState({ open: false, text: '' });

    /* Reset passwd */
    function onPasswdResetPressed() {
        const emailError = emailValidator(email.value);

        if (emailError) {
            setEmail({ ...email, error: emailError })
            return;
        }
        authReset();
    }

    async function authReset() {
        setErrorText("");
        try {
            await comm_resetPassword(email.value);
            setSnack({
                ...snack, open: true,
                text: 'Se ha enviado un email con instrucciones para resetear la contraseña'
            });
        }
        catch (e) {
            setErrorText(errorCodeTranslator(e));
        }
    }

    /* Login pressed, fields are validated */
    function onLogInPressed(e) {
        e.preventDefault();

        const emailError = emailValidator(email.value);
        const passwordError = passwordValidator(password.value);

        /* Clean error messages first */
        setEmail({ ...email, error: "" });
        setPassword({ ...password, error: "" });

        /* Check for errors */
        if (emailError || passwordError) {
            setEmail({ ...email, error: emailError });
            setPassword({ ...password, error: passwordError });
            return;
        }

        authLogin();
    };

    async function authLogin() {
        setErrorText("");
        try {
            /* Automatic redirect to home page if correctly login */
            await comm_login(email.value, password.value);
        }
        catch (e) {
            setErrorText(errorCodeTranslator(e));
        }
    }

    /* Login as guest */
    async function onGuestPressed() {
        try {
            await comm_guestLogin();
            // history.push('/');
        }
        catch (e) {
            setErrorText(errorCodeTranslator(e));
        }
    }

    /* Login using Google Provider */
    async function onLoginWithGoogleProvider() {
        try {
            await comm_login_google_provider();
            // history.push("/");
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <>
         <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={onGuestPressed}
                className="sig_SignIn_SubmitButton"
                >
                
                ENTRAR SIN REGISTRO
            </Button>
        
        <form className="sig_SignIn_Form" onSubmit={onLogInPressed}>

            <TextField
                onChange={(e) => {
                    setEmail({ ...email, value: e.target.value });
                }}
                helperText={email.error}
                FormHelperTextProps={{ error: true }}
                variant="outlined"
                margin="dense"
                required
                fullWidth
                id="email"
                label="Correo electrónico"
                autoComplete="email"
                autoFocus
                className="sig_SignIn_LoginInputFields"
            />
            <TextField
                onChange={(e) => {
                    setPassword({ ...password, value: e.target.value });
                }}
                helperText={password.error}
                FormHelperTextProps={{ error: true }}
                variant="outlined"
                margin="dense"
                required
                fullWidth
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                className="sig_SignIn_LoginInputFields"
            />
            <Link href="#" variant="body2" className="sig_SignIn_PassReminder" onClick={onPasswdResetPressed}>
                {t("sLogin.forgotPassword")}
            </Link>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className="sig_SignIn_SubmitButton">
                ENTRAR COMO USUARIO REGISTRADO
            </Button>
            <Button fullWidth variant="outlined" color="primary" onClick={onLoginWithGoogleProvider} className="sig_SignIn_GoogleProviderButton">
                <div className="sig_SignIn_GoogleProviderButton_Text">{t("sLogin.googleButton")}</div>
                <FcGoogle size={25} />
            </Button>
            
            <br />
            {errorText && <Typography variant="body1" color="error">
                {errorText}
            </Typography>
            }
            <HelpSnackbar snack={snack} setSnack={setSnack} />
        </form >
        </>
    )
}
